export type VehiclePageItem = number | 'gap';

export type VehiclePageState = {
    page: number;
    pageCount: number;
    /** 1-based range of the shown vehicles; 0–0 without results. */
    from: number;
    to: number;
};

export function pageState(total: number, perPage: number, requested: number): VehiclePageState {
    const pageCount = Math.max(1, Math.ceil(total / perPage));
    const page = Math.min(Math.max(1, requested), pageCount);

    return {
        page,
        pageCount,
        from: total ? (page - 1) * perPage + 1 : 0,
        to: Math.min(page * perPage, total),
    };
}

/** Up to seven pages in full; beyond that first, last and the neighbours of the current one. */
export function pageItems(page: number, pageCount: number): VehiclePageItem[] {
    if (pageCount <= 7) return Array.from({ length: pageCount }, (_, index) => index + 1);

    const items: VehiclePageItem[] = [1];
    if (page > 3) items.push('gap');

    for (let item = Math.max(2, page - 1); item <= Math.min(pageCount - 1, page + 1); item++) {
        items.push(item);
    }

    if (page < pageCount - 2) items.push('gap');
    items.push(pageCount);

    return items;
}

/** „1–12 von 48 Fahrzeugen“ below the pages. */
export function rangeLabel({ from, to }: VehiclePageState, total: number): string {
    return total === 1 ? '1 von 1 Fahrzeug' : `${from}–${to} von ${total} Fahrzeugen`;
}

/** Announced politely after every change. */
export function liveLabel({ from, to }: VehiclePageState, total: number): string {
    return total ? `Zeige ${from} bis ${to} von ${total} Fahrzeugen` : 'Keine Fahrzeuge gefunden';
}
